import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import TeamCard from "./TeamCard";
import Groups2Icon from "@mui/icons-material/Groups2";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import { TeamDetails } from "./LeagueSignUp";
import Grid from "@mui/material/Grid2";

export default function ProposedTeamCard({
  title,
  pendingTeam,
  teamDetails,
  teamId,
  teamHandicap,
  devPort,
  tournamentId,
  reloadTeams,
  managerMode,
}: {
  title: string;
  pendingTeam: boolean;
  teamDetails: TeamDetails;
  teamId: string;
  teamHandicap: number;
  devPort: string;
  tournamentId: number;
  reloadTeams: () => void;
  managerMode: number;
}) {
  function handleApproveTeam(status: number) {
    const fetchTeamStatusChange = devPort + "accept_reject_team";
    const statusChangeData = {
      tournament_id: tournamentId,
      team_id: teamId,
      accept_reject: status,
    };
    fetch(fetchTeamStatusChange, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(statusChangeData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        reloadTeams();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  return (
    <Card sx={{ height: "100%", position: "relative" }}>
      {pendingTeam && managerMode === -1 && (
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            display: "flex",
            gap: 1,
          }}
        >
          <IconButton color="success" size="small" onClick={() => handleApproveTeam(1)}>
            <CheckIcon />
          </IconButton>
          <IconButton color="secondary" size="small" onClick={() => handleApproveTeam(2)}>
            <CloseIcon />
          </IconButton>
        </Box>
      )}
      <CardContent>
        <Groups2Icon color="secondary" />
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <Typography
              component="h2"
              variant="subtitle2"
              gutterBottom
              sx={{ fontWeight: "600" }}
            >
              {title}
            </Typography>
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Typography variant="body2" color="text.secondary">
              Handicap: {teamHandicap}
            </Typography>
          </Grid>
        </Grid>
        <TeamCard teamMembers={teamDetails.positions} />
      </CardContent>
    </Card>
  );
}
